import React from 'react';

import AccountConfirmationArea from 'components/sections/account-confirmation-area';

const AccountConfirmation = () => (
  <AccountConfirmationArea />
);

export default AccountConfirmation;
